import React, { useEffect, useState } from "react";

import { connect } from 'react-redux';
import { getdepartmentData, getCurriculumData, getProgramData, getTermsData } from '../../../redux/actions/dataAction';

import CustomHeading from "../../../constants/CustomHeading";
import CustomDropdown from '../../../constants/CustomDropdown';
import CustomFilter from '../../../constants/CustomFilter';
import CustomTableWithAll from "../../../constants/CustomTableWithAll";

const ManageISE_MSEOccassion = (props) => {

  const [filterData, setFilterData] = useState([]);
  const [filter,setFilter]=useState({
    department:'Select Department',
    program:'Select Program',
    curriculum:'Select Curriculum',
    term:'Select Term'
  });

  useEffect(() => {
    props.getCurriculumData();
    props.getProgramData();
    props.getdepartmentData();
    props.getTermsData();
  }, []);

  
  const handleChange = (event) => {
    setFilter(({...filter,[event.target.id]:event.target.value}));
  }

  const FilterTableData=()=>{
    let data=CustomFilter(props?.department?.data,[
      {value:filter.term,label:'group',initial_value:'Select Term'},
      {value:filter.department,label:'department',initial_value:'Select Department'},
      {value:filter.program,label:'program',initial_value:'Select Program'},
      {value:filter.curriculum,label:'curriculum',initial_value:'Select Curriculum'},
    ]);
    setFilterData(data);
  }

  useEffect(()=>{
    FilterTableData()
  },[props?.department?.data, filter]);

  const columns=[
    {title:'SI No.', field:'serial_number'},
    {title:'Section', field:'section'},
    {title:'Code', field:'course_code'},
    {title:'Course Title', field:'course_title'},
    {title:'Core/Elective', field:'core_elective'},
    {title:'Instructor', field:'instructor'},
    {title:'Mode', field:'mode'},
    {title:'Import Ocassion', field:'import'},
    {title:'Status', field:'status'},
  ]

  return (
    <div className="customContainer">
      <CustomHeading title="Manage ISE & MSE Occasion List" />
      <div className="row my-0">
        <div className="col-md-4">
           <CustomDropdown
            id="department"
            label="Department :"
            data={
              props?.department?.data?.map(res => {
                return (
                  { value: res.name }
                );
              })
            }
            notDefaultOption
            defaultOption={"Select Department"}
            onChange={handleChange}
            />
        </div>
        <div className="col-md-4">
           <CustomDropdown
            id="program"
            label="Program :"
            data={
              props?.program?.data?.map(res => {
                return (
                  { value: res.name }
                );
              })
            }
            notDefaultOption
            defaultOption={"Select Program"}
            onChange={handleChange}
            />
        </div>
        <div className="col-md-4">
           <CustomDropdown
            id="curriculum"
            label="Curriculum :"
            data={
              props?.curriculum?.data?.map(res => {
                return (
                  { value: res.name }
                );
              })
            }
            notDefaultOption
            defaultOption={"Select Curriculum"}
            onChange={handleChange}
            />
        </div>
        <div className="col-md-4">
           <CustomDropdown
            id="term"
            label="Term :"
            data={
              props?.term?.data?.map(res => {
                return (
                  { value: res.name }
                );
              })
            }
            notDefaultOption
            defaultOption={"Select Term"}
            onChange={handleChange}
            />
        </div>
      </div>
      <div className="customContainer mb-5">
      <CustomTableWithAll data={filterData} title={"Occassion List"} buttonRequired={false} columns={columns} api="/api/department/" identify="Occassion  List" />
      </div>
    </div>
  );
};

const mapActionWithProps = {
  getdepartmentData,
  getCurriculumData,
  getProgramData,
  getTermsData,
}

const mapStateWithProps = (state) => (
  {
    department: state.data.department,
    curriculum: state.data.curriculums,
    program: state.data.program,
    term: state.data.terms,
  }
)

export default connect(mapStateWithProps, mapActionWithProps) (ManageISE_MSEOccassion);